import { launcherOpenUrl } from '../../launcherBackend/launcher-command'
import styles from './login-window.scss'

// Used to logout from the SSO, allowing additional accounts to be signed in
export const logoutFromSSO = (serverSsoUrl, currentUrl, targetUrl, logoutUrl, iframe) => {
    // Make sure that the current URI isn't the logon path
    // no reason to create an infinite loop or try logging out
    // when you're already logged out
    if (currentUrl.indexOf('LogOn') === -1) {
        // Make sure that both the target url and
        // single sign on server host have been defined
        if (targetUrl !== undefined && serverSsoUrl !== undefined) {
            // Combine the information into a single string
            const destination = logoutUrl
                .replace('{host}', serverSsoUrl)
                .replace('{returnURI}', encodeURIComponent(targetUrl))

            // Update the iframe source with the new URI
            iframe.attr('src', destination)
        }
    }
}

// Functionality for the "Remember this account" checkbox to the iframe
export const addRememberAccountCheckbox = async (
    iframe,
    href,
    rememberAccount,
    rememberText,
    insecureText,
) => {
    const contents = iframe.contents()

    // Make sure that we only apply the checkbox if we're on
    // the /account/logon page where there is no 2FA checkbox
    if (
        !href.match(/(\/account\/logon)/gi) ||
        contents.find('.authenticator-checkbox').length !== 0
    ) {
        return
    }

    // Make sure that we only inject remember account once
    if (contents.find('#remember-account').length === 0) {
        // Add the checkbox to the iframe
        contents
            .find('.row:first')
            .before(
                `<div class="row" style="width:auto;"><label for="remember-account"><input type="checkbox" id="remember-account" name="remember-account" /> ${rememberText} <span class="unsecure">${insecureText}</span></label></div>`,
            )
    }

    const checkbox = contents.find('#remember-account')

    rememberAccount.remember = checkbox.is(':checked')

    // Listen for events for the checkbox
    checkbox.on('click', (event) => {
        rememberAccount.remember = event.target.checked
    })
}

// Update styles of the SSO login iframe
export const updateIframeStyles = (iframe) => {
    // Retrieve the conents of the iframe
    const contents = iframe.contents()

    // Find the username and password fields
    // and update their width
    contents.find('#UserName, #Password').css('width', '314px')

    // Remove additional padding at top of the login window
    contents.find('#loginbody').css('padding-top', '0')

    // Change the width of the launcher rows
    contents.find('.row').css('width', '330px')

    contents.find('.linking-in-launcher #content').css('max-width', '100%')

    // Set default focus on the username field
    contents
        .find('#UserName')
        .select()
        .focus()
}

export const checkIfEULA = (iframe, url, style) => {
    const regex = '([^#]+)(#eula$)'

    const matches = new RegExp(regex, 'gi').exec(url)
    if (matches) {
        iframe.addClass(style)
    } else {
        iframe.removeClass(style)
    }
}

// Correct the opening of links in the SSO iframe
export const correctOpenLinks = (iframe) => {
    // Search the contents of the iframe for any clicks
    // on the a property
    iframe
        .contents()
        .find('a')
        .on('click', (event) => {
            // Remove content meant for the old launcher
            const href = event.target.href.replace('launcher:openurl:', '')

            // If the link is for authentication mails we return the function back to normal
            if (href.toLowerCase().indexOf('/account/authenticationmail') !== -1) return

            // If the link fits any other pattern we prevent
            // the default behavior
            event.preventDefault()

            // If the href is defined and is more than three
            // characters long we open the link
            if (href !== undefined && href.length > 3) {
                launcherOpenUrl(href)
            }
        })
}

/* Exposed commands */

const showEula = () => {
    // Get the iframe element
    const iframe = document.getElementById('sso-frame')

    if (iframe == null) return

    // Get the current classes
    const currentClasses = iframe.className

    // Append the class if it is missing
    if (currentClasses.indexOf(styles.eula) === -1) {
        iframe.className = `${currentClasses} ${styles.eula}`
    }
}

window.showEula = showEula



// WEBPACK FOOTER //
// ./src/components/LoginWindow/sso-commands.js